import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { Flex, Box } from 'rebass'
import media, { Grid } from '../../utils/style'

import typography from '../../utils/typography'
import HeaderLogo from '../HeaderLogo'
import HeaderOmniSearch from '../HeaderOmniSearch'
import RouterAccount from '../RouterAccount'

import { Link } from 'gatsby'

const ContainerDivider = styled.div`
  position: relative;
  z-index: 2;
  background: ${(props) => props.theme.colors.white};
  border-bottom: 1px ${(props) => props.theme.colors.grey_light_op30} solid;
  height: ${typography.rhythm(2)};
  display: flex;
  align-items: center;
  justify-content: center;
`

const Aligner = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-grow: 1;
`

const Contact = styled(Box)`
  line-height: 1.2;
  z-index: 4;
`

const ContactSmallText = styled(Box)`
  font-size: ${rem('13px')};
  letter-spacing: 0.41px;
  line-height: 1;
  align-items: center;
  color: ${(props) => props.theme.colors.grey_light};

  > strong {
    color: ${(props) => props.theme.colors.blue};
  }

  a {
    white-space: nowrap;
    cursor: pointer;
    text-decoration: none;
  }

  > a {
    color: ${(props) => props.theme.colors.grey_light};
    text-decoration: none;
  }

  > strong > a {
    color: ${(props) => props.theme.colors.blue};

    &:hover {
      color: ${(props) => props.theme.colors.grey};
    }
  }
`

const HeaderWrapper = styled(Flex)`
  position: relative;
  z-index: 103;
`

const Search = styled(Box)``

const searchItems = []

const ContactSmallTextGrid = styled(Grid)`
  ${media.LargeScreenUp`
    padding-left: 32px;
    padding-right: 32px;
    `}
`

const RouterAccountWrapper = styled.div`
  display: flex;
  width: 150px;
  margin-bottom: -7px;
`

const RouterAccountGrid = styled(Grid)`
  padding-left: 16px;
`

const HeaderExpanded = ({
  onHadAnAccident,
  phoneNumber,
  calltracksClass,
  location
}) => (
  <HeaderWrapper width={1} className="HeaderExpanded">
    <Box width={[2 / 12]}>
      <HeaderLogo location={location} />
    </Box>
    <Search width={[null, 1 / 12, 3 / 12, 4 / 12]} flexGrow={1}>
      <HeaderOmniSearch results={searchItems} />
    </Search>

    <Contact width={[null, 4 / 12, 8 / 12, 6 / 12]}>
      <ContainerDivider>
        <Aligner>
          <Grid>
            <ContactSmallText>
              <strong>
                <Link to="/locations">Contact us</Link>
              </strong>
            </ContactSmallText>
          </Grid>
          <ContactSmallTextGrid px={[2, null, null, 4]}>
            <ContactSmallText mr={[2, null, null, 4]}>
              <strong>
                <a onClick={onHadAnAccident} title="Accident advice">
                  Had an Accident?
                </a>
              </strong>
            </ContactSmallText>
            <ContactSmallText>
              <strong>
                <a href="/customer-feedback" title="Customer feedback">
                  Customer feedback
                </a>
              </strong>
            </ContactSmallText>
          </ContactSmallTextGrid>
        </Aligner>
        <RouterAccountWrapper>
          <RouterAccountGrid pl={3}>
            <RouterAccount favourites={4} />
          </RouterAccountGrid>
        </RouterAccountWrapper>
      </ContainerDivider>
    </Contact>
  </HeaderWrapper>
)

export default HeaderExpanded
